import clsx from 'clsx'
import React, { useRef, useEffect, useContext, useState } from 'react'

import { Icon } from '@/components/Icon'

import { CollectionContext } from './collection-context'

import './SortSelect.scss'

type Props = {
  isDesktopScreen: boolean
}

export const SortSelect: React.FC<Props> = ({ isDesktopScreen }) => {
  const { sortby, appliedSorting, setAppliedSorting } =
    useContext(CollectionContext)

  const [selectWidth, setSelectWidth] = useState<string | null>(null)
  const [labelWidth, setLabelWidth] = useState<string | null>(null)

  const selectRef = useRef<HTMLSelectElement>(null)
  const selectHelperRef = useRef<HTMLSpanElement>(null)
  const labelRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    selectHelperRef.current &&
      setSelectWidth(`${selectHelperRef.current.offsetWidth}px`)
    labelRef.current && setLabelWidth(`${labelRef.current.offsetWidth}px`)
  }, [appliedSorting])

  const handleSortingChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const sortOption = sortby?.items.find(
      (sortOption) => sortOption._id === event.target.value,
    )
    if (!sortOption) return

    setAppliedSorting(sortOption)
  }

  if (!sortby) return null

  const style = {
    ...(selectWidth ? { '--sort-select-width': selectWidth } : {}),
    ...(labelWidth ? { '--sort-label-width': labelWidth } : {}),
  } as React.CSSProperties

  return (
    <label className="collection-sort-select type-label" style={style}>
      <span ref={labelRef} className="collection-sort-select__label">
        Sort:
      </span>
      <select
        ref={selectRef}
        className={clsx('collection-sort-select__select')}
        value={appliedSorting?._id}
        onChange={handleSortingChange}
      >
        {sortby.items.map((sortOption) => (
          <option
            id={sortOption?.label}
            key={sortOption._id}
            value={sortOption._id}
          >
            {sortOption.label}
          </option>
        ))}
      </select>
      <span
        ref={selectHelperRef}
        className="collection-sort-select__select-helper"
      >
        {appliedSorting?.label || sortby.items[0]?.label}
      </span>
      {isDesktopScreen && (
        <span className="collection-sort-select__icon">
          <Icon name="chevron" />
        </span>
      )}
    </label>
  )
}
